<template>
  <el-dialog
    :class="['custom-dialog', {'hide-title': hideTitle}]"
    :close-on-click-modal="clickOnModal"
    :visible.sync="dialogVisi"
    :width="width"
    @closed="$emit('closed')">
    <p 
      slot="title" 
      class="slot-title"
      v-show="!hideTitle">
      <slot name="title">{{title}}</slot>
    </p>
    <slot name="content"></slot>
    <div 
      class="dialog-btns"
      v-show="!hideFooter">
      <slot name="footer">
        <el-button 
          type="info" 
          size="small" 
          @click="$emit('cancel')"
          :loading="cancelLoading"
          v-show="!hideCancel">
          {{cancelText}}
        </el-button>
        <el-button 
          type="primary" 
          size="small" 
          @click="$emit('confirm')"
          :loading="confirmLoading">
          {{confirmText}}
        </el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'default',
  data () {
    return {
    }
  },
  computed: {
    dialogVisi: {
      get(){
        return this.visi
      },
      set(val){
        this.$emit('update:visi', val)
      }
    }
  },
  props: {
    visi: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: '95%'
    },
    confirmText: {
      type: String,
      required: false,
      default: '确定'
    },
    cancelText: {
      type: String,
      required: false,
      default: '取消'
    },
    title: {
      type: String,
      required: false,
      default: '标题'
    },
    confirmLoading: Boolean,
    cancelLoading: Boolean,
    hideTitle: Boolean,
    hideFooter: Boolean,
    hideCancel: Boolean,
    clickOnModal: Boolean
  }
}
</script>

<style lang="scss">
.custom-dialog{
  .el-dialog{
    border-radius: 0.175rem;
    .el-dialog__header{
      padding: 0;
      background-color: #169BD5;
      border-radius: 0.175rem 0.175rem 0 0;
      position: relative;
      .slot-title{
        margin: 0;
        height: 3.5rem;
        line-height: 3.5rem;
        font-size: 1.1375rem;
        font-weight: bold;
        color: #FFF;
        padding: 0 .7rem;
      }
      .el-dialog__headerbtn{
        @extend .abs-midY;
        font-size: 1.575rem;

        .el-icon-close{
          color: #fff;
          font-weight: bold;
          transition: transform .3s;
        }

        &:hover{
          .el-icon-close{
            transform: scale(1.1);
          }
        }
      }
    }

    .el-dialog__body{
      padding: 0;

      .el-form{
        padding: 0.875rem;
      }

      .dialog-btns{
        border-top: 0.0175rem solid #E4E4E4;
        text-align: center;
        padding: 0.875rem 0;
      }
    }
  }

  &.hide-title{
    .el-dialog__headerbtn{
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomDialog.vue